import React from 'react'
import SignUpContainer from './SignUpContainer'

const SignUp = (props) => (
  <SignUpContainer {...props} />
)

export default SignUp



// WEBPACK FOOTER //
// ./src/routes/SignUp/index.js